import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import MovimentacaoRecebimentoHttp from '../../../../services/api/https/patrimonio/movimentacao-recebimento.http'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import PatrimonioOwnerHttp from '../../../../services/api/https/patrimonio/patrimonio-owner.http'
import AtivoPatrimonialHttp from '../../../../services/api/https/patrimonio/ativo-patrimonial.http'
import { DateTime } from 'luxon'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_RECEIPTS: 'Adquirindo Movimentações de Recebimento',
  FILTERING: 'Filtrandos Movimentações de Recebimento',
  CANCEL: 'Cancelando recebimento',
  ISSUE_RECEIPT: 'Emitindo recibo de recebimento',
  SALVAR_IMPORTACAO: 'Salvando Importação',
}

const INITIAL_STATE = {
  movimentacoes: [],
  selectedMovimentacao: null,
  globalFilter: '',
  periodo: getPeriodoMesAtual(),
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  recebimentoImportacao: [],
}

export const MODEL_EXCEL = [
  [
    'tp_id',
    'data_movimentacao(dd/mm/yyyy)',
    'transportadora_id',
    'num_viagem',
    'patrimonio_owner_id',
    'veiculo_transferencia_id',
    'patrimonio_id',
    'qte_total',
    'observações',
  ],
]
export default function useMovimentacaoRecebimento() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getMovimentacoesRecebimento(pInicial, pFinal, tpId) {
        MovimentacaoRecebimentoHttp.getMovimentacoesRecebimento(pInicial, pFinal, tpId)
          .then(movimentacoes =>
            setState(prevState => ({
              ...prevState,
              movimentacoes: movimentacoes,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp)
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_RECEIPTS }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
      },

      onModalEvent(action, payload) {
        switch (action) {
          case 'save':
            setState(prevState => {
              const index = prevState.movimentacoes.findIndex(mov => mov.id === payload.id)
              if (index !== -1) prevState.movimentacoes[index] = payload
              else prevState.movimentacoes.push(payload)
              prevState.modal.show = false
              prevState.modal.data = null
              return { ...prevState }
            })
            break

          case 'close':
            setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
            break

          default:
            break
        }
      },

      onNovoClick(selectedTp) {
        if (selectedTp) setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
        else
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Operador Logístico' }))
      },

      onBtnPesquisarClick(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
          loadingMessage: LOAD_MESSAGE.FILTERING,
        }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onMenuItemClick(menuItem, item, history) {
        switch (menuItem) {
          case 'Editar':
            setState(prevState => ({ ...prevState, modal: { show: true, data: item } }))
            break

          case 'Emitir Comprovante':
            MovimentacaoRecebimentoHttp.emitirComprovante(item.id)
            break

          case 'Upload Comprovante':
            history.push({
              pathname: '/main/patrimonio/movimentacao-recebimento/upload-comprovante',
              state: { movimentacao_id: item.id },
            })
            break

          default:
            break
        }
      },

      async onBtnExportarExcel(movimentacoes) {
        let allOwners = ''
        let allPatrimonios = []

        await PatrimonioOwnerHttp.fetchOwners()
          .then(owners => (allOwners = owners))
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
            })),
          )

        await AtivoPatrimonialHttp.fetchAtivos()
          .then(patrimonios => (allPatrimonios = patrimonios))
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )

        const colunas = [
          [
            'id',
            'data_movimentacao',
            'tp',
            'nome_transportadora',
            'num_viagem',
            'patrimonio_owner',
            'placa',
            'patrimonio',
            'qte_total',
            'observações',
          ],
        ]

        movimentacoes.forEach(m => {
          const patrimonioOwnerName = allOwners.find(ao => ao.id === m.patrimonio_owner_id).name
          m.patrimonios.forEach(p => {
            colunas.push([
              m.id,
              m.data_movimentacao,
              getTps().find(tp => tp.id === m.tp_id).name,
              m.nome_transportadora,
              m.num_viagem,
              patrimonioOwnerName,
              m.placa,
              allPatrimonios.find(aP => aP.id === p.patrimonio_ativo_id).name,
              p.qte_total,
              m.observacoes,
            ])
          })
        })

        gerarArquivoExcel(
          'entregas',
          colunas,
          `movimentacoes_recebimento_${new Date().toLocaleString().slice(0, 10)}.xlsx`,
        )
      },

      onFileImported(content, selectedTp) {
        try {
          const isPlanilhaNoPadrao = this._planilhaNoPadrao(content)
          if (!isPlanilhaNoPadrao) {
            throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
          }

          const recebimentos = this._buildRecebimentos(content, selectedTp)

          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.SALVAR_IMPORTACAO,
            recebimentoImportacao: recebimentos,
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error.message),
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        }
      },

      _planilhaNoPadrao(content) {
        const header = content[0]

        return (
          header[0] === 'tp_id' &&
          header[1] === 'data_movimentacao(dd/mm/yyyy)' &&
          header[2] === 'transportadora_id' &&
          header[3] === 'num_viagem' &&
          header[4] === 'patrimonio_owner_id' &&
          header[5] === 'veiculo_transferencia_id' &&
          header[6] === 'patrimonio_id' &&
          header[7] === 'qte_total' &&
          header[8] === 'observações'
        )
      },

      _buildRecebimentos(content, selectedTp) {
        const body = content.splice(1)
        const result = []

        body.forEach((row, index) => {
          if (
            !row[0] ||
            isNaN(Number(row[0])) ||
            !row[1] ||
            !DateTime.fromFormat(row[1], 'dd/MM/yyyy').isValid ||
            !row[2] ||
            isNaN(Number(row[2])) ||
            !row[3] ||
            isNaN(Number(row[3])) ||
            !row[4] ||
            isNaN(Number(row[4])) ||
            !row[5] ||
            isNaN(Number(row[5])) ||
            !row[6] ||
            isNaN(Number(row[6])) ||
            !row[7] ||
            isNaN(Number(row[7]))
          ) {
            throw new Error(
              `Erro próximo a linha ${index + 2} da planilha. Conteúdo inconsistente.`,
            )
          }

          const findResult = result.find(r => r.num_viagem === row[2])

          if (findResult) {
            findResult.patrimonios.push({
              patrimonio_ativo_id: row[5],
              qte_total: Number(row[6]),
            })
            return
          }

          result.push({
            tp_id: row[0],
            data_movimentacao: DateTime.fromFormat(row[1], 'dd/MM/yyyy').toFormat('yyyy-MM-dd'),
            transportadora_id: row[2],
            created_by_user_id: getUsuarioInfo().id,
            num_viagem: row[3],
            patrimonio_owner_id: row[4],
            veiculo_transferencia_id: row[5],
            patrimonios: [
              {
                patrimonio_ativo_id: row[6],
                qte_total: Number(row[7]),
              },
            ],
            observacoes: row[8],
            type: 'recebimento',
          })
        })
        return result
      },

      async salvarImport(recebimentos) {
        try {
          if (recebimentos.length === 0) {
            throw new Error('Não existem Recebimentos para Importação')
          }
          await MovimentacaoRecebimentoHttp.saveMovimentacaoMassively(recebimentos)
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.FILTERING,
            recebimentoImportacao: [],
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
